import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { useParams } from 'react-router-dom';
import { useTitle } from 'shared/hooks';
import { ProvideDistributor } from 'shared/providers';
import { createTableDataContext, ProvideTableData } from 'shared/providers/provideTableData';
import { CurrentPricesData } from 'types/backend';
import { ManagePricing } from './managePricing';

export const managePricingContext = createTableDataContext<CurrentPricesData>();

export type AccountNumberParams = {
    accountNumber: string;
};

export default function ManagePricingResolver() {
    useTitle(`Current Prices - Paragon`);
    const params = useParams<AccountNumberParams>();

const defaultManagePricingConfig: {initialState?: GridInitialStatePremium} | undefined = {
        initialState: {
            pagination: {
                paginationModel: {
                    page: 0,
                    pageSize: 100,
                },
            }
        },
    }

    return (
        <ProvideDistributor>
            <ProvideTableData
                name='CurrentPricesUI'
                tableDataContext={managePricingContext}
                alternateQueryPath={`subset/${params.accountNumber}`}
                config={defaultManagePricingConfig}
            >
                <ManagePricing />
            </ProvideTableData>
        </ProvideDistributor>
    );
}
